import React from 'react';

const STEPS = [
  'Plug in your new MessageBeacon',
  'Wait until the light goes solid red',
  'On your phone or laptop, open WiFi settings',
  'Connect to the network called "MessageBeacon_setup"',
  "A setup page will open automatically. If it doesn't, open a browser and go to http://192.168.4.1",
  'Enter the requested details',
  'Tap Connect Beacon',
  'The beacon will restart and connect automatically',
  'The process is complete when your beacon goes green for a few seconds, then the light goes out',
];

export default function SetupPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#f8f9fa',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      padding: '40px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        padding: '36px 32px',
        maxWidth: 540,
        width: '100%',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        {/* Header */}
        <div style={{ marginBottom: 32, textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>📡</div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111', margin: 0, marginBottom: 8 }}>
            MessageBeacon Setup
          </h1>
          <p style={{ fontSize: 15, color: '#666', margin: 0 }}>
            Follow these steps to get your beacon connected.
          </p>
        </div>

        {/* Steps */}
        <ol style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 16 }}>
          {STEPS.map((step, i) => (
            <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>
              <div style={{
                width: 28, height: 28, borderRadius: '50%',
                background: '#1a73e8', color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 13, fontWeight: 700, flexShrink: 0, marginTop: 1,
              }}>
                {i + 1}
              </div>
              <span style={{ fontSize: 15, color: '#222', lineHeight: '28px', flex: 1 }}>{step}</span>
            </li>
          ))}
        </ol>

        {/* Footer */}
        <div style={{
          marginTop: 32, paddingTop: 24,
          borderTop: '1px solid #eee',
          textAlign: 'center',
          fontSize: 13, color: '#999',
        }}>
          Need help? Contact us
        </div>
      </div>
    </div>
  );
}
